import { Any, JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";

@JsonConverter
export class CaptiveDeviceAccountDataConverter implements JsonCustomConvert<CaptiveDeviceAccount> {
	serialize() { }
	deserialize(data: any): CaptiveDeviceAccount {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, CaptiveDeviceAccount);
	}
}

@JsonConverter
export class CaptiveDeviceAccountArrayConverter implements JsonCustomConvert<Array<CaptiveDeviceAccount>> {
	serialize() { }
	deserialize(data: any): Array<CaptiveDeviceAccount> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, CaptiveDeviceAccount);
	}
}

@JsonObject("CaptiveDeviceAccount")
export class CaptiveDeviceAccount {
	@JsonProperty("identity_email", String, true)
	identity_email: string = "";
	@JsonProperty("username", String, true)
	username: string = "";
	@JsonProperty("strategy", String, true)
	strategy: string = "";
	@JsonProperty("created_at", Any, true)
	created_at: any = null;
	@JsonProperty("last_login", Any, true)
	last_login: any = null;
	@JsonProperty("valid", Any, true)
	valid: any = null;
	@JsonProperty("status", String, true)
	status: string = "";
	@JsonProperty("registration_location_id", String, true)
	registration_location_id: string = "";
	@JsonProperty("sponsor_email", String, true)
	sponsor_email: string = "";
}

@JsonObject("CaptiveDeviceAccountArray")
export class CaptiveDeviceAccountData extends BaseResponse {
	@JsonProperty("data", CaptiveDeviceAccountDataConverter, true)
	data: CaptiveDeviceAccount = new CaptiveDeviceAccount();
}

@JsonObject("CaptiveDeviceAccountArrayData")
export class CaptiveDeviceAccountArrayData extends BaseResponse {
	@JsonProperty("data", CaptiveDeviceAccountArrayConverter, true)
	data: Array<CaptiveDeviceAccount> = new Array<CaptiveDeviceAccount>();
}
